import React, { useState, useCallback } from "react";
import ImageViewer from "react-simple-image-viewer";

export const Gallery = props => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const data = [
    { thumb: "img/appimages/one.png", title: " " },
    { thumb: "img/appimages/two.png", title: " " },
    { thumb: "img/appimages/three.png", title: " " },
    { thumb: "img/appimages/four.png", title: " " },
    { thumb: "img/appimages/five.png", title: " " },
    { thumb: "img/appimages/six.png", title: " " },
    { thumb: "img/appimages/seven.png", title: " " },
  ];

  const images = data.map(obj => obj.thumb.replace("-small", "-large"));

  const openImageViewer = useCallback(index => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <div id="portfolio" style={{ paddingTop: "0", paddingBottom: "40px" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div style={{ 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center",
              flexWrap: "wrap",
              gap: "15px"
            }}>
              {data.map(({ thumb }, index) => (
                <div 
                  key={index} 
                  onClick={() => openImageViewer(index)} 
                  style={{
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                    overflow: "hidden"
                  }}
                  onMouseOver={(e) => { e.currentTarget.style.transform = "scale(1.09)" }}
                  onMouseOut={(e) => { e.currentTarget.style.transform = "scale(1)" }}
                >
                  <img
                    src={thumb}
                    alt={`App screenshot ${index + 1}`}
                    style={{ 
                      width: "120px", 
                      height: "200px", 
                      objectFit: "cover",
                      display: "block"
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {isViewerOpen && (
          <ImageViewer
            src={images}
            backgroundStyle={{ zIndex: 99999 }}
            currentIndex={currentImage}
            onClose={closeImageViewer}
          />
        )}
      </div>
    </div>
  );
};